module.exports = __webpack_public_path__ + "static/img/scenery-02.01c74b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/scenery-02.jpg
// module id = 19SE
// module chunks = 0